// Base SWT (Standard Work Time)
export const swtBaseTsbValue = 0.75;

// Installation fee calculation constants
export const installationFeeHourlyRate = 118.2; // $118.20 per SWT hour
export const installationFeeMinimum = 199; // Minimum installation fee
